module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M13.312 23.68l-6.976-6.816a.966.966 0 0 1 0-1.376l1.408-1.376a1.004 1.004 0 0 1 1.408 0l4.864 4.768 8.832-10.56a1.004 1.004 0 0 1 1.408 0l1.408 1.376a.966.966 0 0 1 0 1.376L14.72 23.68a1.004 1.004 0 0 1-1.408 0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/checkbox-highlight.js
// module id = 1058
// module chunks = 14